module.exports = __webpack_public_path__ + "static/modern-niagara-logo-615054f700302028ad323d2a15625af3.png";